import { useEffect, useState } from 'react'

const useViewportWidth = () => {
  const [viewport, setViewport] = useState(window.innerWidth)

  useEffect(() => {
    const onresize = () => setViewport(window.innerWidth)
    window.addEventListener('resize', onresize)

    return () => window.removeEventListener('resize', onresize)
  }, [])

  return viewport
}

export default useViewportWidth
